export default __webpack_public_path__ + "static/media/gallery_15.089fd7a6.jpg";